// VisionEnvironment — wallpaper detrás de todo. Soporta fondos de COLOR (gradiente
// + orbes + tinte) e IMAGEN (foto con blur + scrim). El tinte global hace que
// cambiar de fondo se note claramente en toda la app (no solo en los márgenes).
import { WALLPAPERS } from "@/lib/wallpapers";

export function VisionEnvironment({ wallpaperKey }: { wallpaperKey: string }) {
  const wp = WALLPAPERS[wallpaperKey] ?? WALLPAPERS.aurora!;

  if (wp.type === "image") {
    return (
      <div aria-hidden className="vision-env pointer-events-none absolute inset-0 z-0 overflow-hidden bg-[var(--color-base)]">
        <img
          src={wp.url}
          alt=""
          className="absolute inset-0 h-full w-full object-cover"
          style={{ filter: "blur(3px) saturate(120%) brightness(0.8)" }}
        />
        {/* Scrim suave: la foto se ve, pero el cristal sigue legible (el contenido
            vive en su ventana opaca aparte). */}
        <div className="absolute inset-0" style={{ background: "rgba(8,8,12,0.42)" }} />
        <div className="noise-layer absolute inset-0 opacity-[0.03]" />
      </div>
    );
  }

  return (
    <div aria-hidden className="vision-env pointer-events-none absolute inset-0 z-0 overflow-hidden bg-[var(--color-base)]">
      {/* Tinte global del color del fondo (hace que el cambio se note en toda la app) */}
      <div className="absolute inset-0" style={{ background: wp.swatch[0], opacity: 0.14 }} />
      <div className="absolute inset-0" style={{ background: wp.base }} />
      <div
        className="absolute -left-[12%] top-[2%] h-[680px] w-[680px] rounded-full"
        style={{ background: `radial-gradient(circle, ${wp.orbs[0]} 0%, transparent 70%)`, filter: "blur(45px)", opacity: 0.9 }}
      />
      <div
        className="absolute right-[-12%] bottom-[0%] h-[620px] w-[620px] rounded-full"
        style={{ background: `radial-gradient(circle, ${wp.orbs[1]} 0%, transparent 70%)`, filter: "blur(45px)", opacity: 0.9 }}
      />
      <div className="noise-layer absolute inset-0 opacity-[0.035]" />
      <div
        className="absolute inset-0"
        style={{ background: "radial-gradient(130% 130% at 50% 50%, transparent 50%, rgba(0,0,0,0.4) 100%)" }}
      />
    </div>
  );
}
